import React from "react"
import { Select, MenuItem, makeStyles, Theme } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import { fieldTypes } from "./AddFields"

import { ArrowDropDownRounded as ArrowDropDownRoundedIcon } from "@material-ui/icons"
import { useFormContext, Controller } from "react-hook-form"
import { useCommonFieldProps } from "./CommonFieldPropsContext"

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {
    "& .MuiSelect-root": {
      position: "relative",
      top: 5,
    },
    "& .MuiSelect-icon": {
      right: -theme.spacing(1),
    },
  },
}))

export const ChangeFieldType: React.FC = () => {
  /** Get common schema field props */
  const { field, index } = useCommonFieldProps()

  /** Get scoped CSS classes */
  const classes = useStyles()
  const { control } = useFormContext()

  const variantInputName = `fields[${index}].variant`

  return field ? (
    <Controller
      as={
        <Select
          disableUnderline
          IconComponent={ArrowDropDownRoundedIcon}
          className={classes.root}
        >
          {fieldTypes.map(fieldType => (
            <MenuItem key={fieldType.type} value={fieldType.template.variant}>
              {fieldType.type}
            </MenuItem>
          ))}
        </Select>
      }
      name={variantInputName}
      rules={{ required: "Required" }}
      control={control}
      defaultValue={field.variant}
    />
  ) : (
    <Skeleton width={180} />
  )
}
